export default function promiseMapSeries(array, iterator) {
    let current = Promise.resolve();

    let results = array.map((item, i, arr) => {
        let next = current.then(() => iterator(item, i, arr));
        current = next;
        return next;
    });

    return Promise.all(results);
}



// WEBPACK FOOTER //
// ./src/utils/promiseMapSeries.js